import { render, staticRenderFns } from "./DragBox2.vue?vue&type=template&id=4a05c713&scoped=true&"
import script from "./DragBox2.vue?vue&type=script&lang=js&"
export * from "./DragBox2.vue?vue&type=script&lang=js&"
import style0 from "./DragBox2.vue?vue&type=style&index=0&id=4a05c713&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a05c713",
  null
  
)

export default component.exports